import { useCallback } from 'react';

import { useModal } from '~/contexts/ModalContext';
import { addToastToSessionStorage } from '~/hooks/useToastsFromLocalStorage';

import type { MiniQuizModalProps } from './MiniQuizModal';

export const addSuccessToastToSessionStorage = () => {
  addToastToSessionStorage({
    type: 'POSITIVE',
    headline: 'All set! Their hellos will appear in your inbox',
    autoDismissInSeconds: 3,
  });
};

export const addSuccessToastToSessionStorageAndReload = () => {
  addSuccessToastToSessionStorage();
  window.location.reload();
};

export const useMiniQuizModal = () => {
  const { showV2PredefinedModal } = useModal();

  const showMiniQuizModal = useCallback(
    (props: MiniQuizModalProps) => {
      showV2PredefinedModal<MiniQuizModalProps>(
        'MINI_QUIZ_MODAL',
        {
          dialogHeadingId: 'dialog-heading',
          triggerRef: null,
          lockBgScrolling: true,
        },
        props
      );
    },
    [showV2PredefinedModal]
  );

  return { showMiniQuizModal };
};
